import React from 'react'
import { connect } from 'react-redux'
import SccListDisplay from './SccListDisplay'

const SccListDisplayContainer = ({
	nonRemovableSccs,
	additionalSccs,
	appliedServices,
	handleRemoveAdditionalScc,
	envConfig,
	autoAdd,
	isDisabled,
}) => {
	return (
		<>
			<SccListDisplay
				nonRemovableSccs={nonRemovableSccs}
				additionalSccs={additionalSccs}
				appliedServices={appliedServices}
				handleRemoveAdditionalScc={handleRemoveAdditionalScc}
				envConfig={envConfig}
				autoAdd={autoAdd}
				isDisabled={isDisabled}
			/>
		</>
	)
}

const mapStateToProps = ({ configs }) => ({
	envConfig: configs,
})

export default connect(mapStateToProps)(SccListDisplayContainer)
